// extracted by mini-css-extract-plugin
export default {"AccountContent":"passwordmanagment_AccountContent__UWvLE","btn__deactive":"passwordmanagment_btn__deactive__DGqAo","btn__delete":"passwordmanagment_btn__delete__7x0PC"};